export type PublicManageParams = {
  token: string;
  action: "reschedule" | "cancel";
};

/** Page client de gestion (reprogrammer / annuler via e-mail). */
export function parsePublicManageParams(): PublicManageParams | null {
  if (typeof window === "undefined") return null;
  const q = new URLSearchParams(window.location.search);
  if (q.get("manage") !== "1") return null;
  const token = q.get("token")?.trim() ?? "";
  if (!token) return null;
  const rawAction = q.get("action")?.trim() ?? "reschedule";
  const action = rawAction === "cancel" ? "cancel" : "reschedule";
  return { token, action };
}

export function isPublicManageRoute(): boolean {
  return parsePublicManageParams() !== null;
}
